import { render, staticRenderFns } from "./criminal.vue?vue&type=template&id=b345c932&scoped=true&"
import script from "./criminal.vue?vue&type=script&lang=js&"
export * from "./criminal.vue?vue&type=script&lang=js&"
import style0 from "./criminal.vue?vue&type=style&index=0&id=b345c932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b345c932",
  null
  
)

export default component.exports